export default function PdpaConsentBanner({ onOpenSettings, onAllowAll, disabled, loading }) {
  return (
    <div className="pdpa-banner" role="dialog" aria-label="แจ้งเตือนความยินยอม PDPA">
      <div className="pdpa-banner-inner">
        <div className="pdpa-banner-copy">
          <div className="pdpa-banner-title">นโยบายความเป็นส่วนตัวและคุกกี้</div>
          <div className="pdpa-banner-text">
            กรุณายอมรับนโยบายของระบบนี้ (ความยินยอมจากระบบอื่นไม่นับรวม)
            อ่านรายละเอียดและเลือกการตั้งค่าคุกกี้ที่เหมาะสม
          </div>
        </div>
        <div className="pdpa-banner-actions">
          <button className="btn btn-ghost btn-sm" onClick={onOpenSettings} disabled={disabled}>
            ตั้งค่า
          </button>
          <button className="btn btn-primary btn-sm" onClick={onAllowAll} disabled={disabled || loading}>
            {loading ? <><i className="fa-solid fa-spinner fa-spin"></i> กำลังบันทึก</> : 'ยอมรับทั้งหมด'}
          </button>
        </div>
      </div>
    </div>
  );
}
